import React from 'react'
import { Row } from 'react-bootstrap'
import AnalyticsPdfStatsCard from './AnalyticsPdfStatsCard'

const ANALYTICS_PDF_STATS_CONFIG = [
  {
    icon: '/assets/icons/eye.svg',
    key: 'totalViews',
    label: 'Total Views',
    alt: 'Views'
  },
  {
    icon: '/assets/icons/users-pro.svg',
    key: 'uniqueVisitors',
    label: 'Unique Visitors',
    alt: 'Visitors'
  },
  {
    icon: '/assets/icons/clock.svg',
    key: 'avgSessionTime',
    label: 'Avg. Session Time',
    alt: 'Time',
    suffix: 's'
  },
  {
    icon: '/assets/icons/presentation.svg',
    key: 'totalPages',
    label: 'Total Pages',
    alt: 'Pages'
  }
]

const AnalyticsPdfOverviewCards = ({ stats }) => (
  <Row className="mb-4">
    {ANALYTICS_PDF_STATS_CONFIG.map(({ icon, key, label, alt, suffix = '' }) => (
      <AnalyticsPdfStatsCard key={key} icon={icon} value={`${stats[key]}${suffix}`} label={label} alt={alt} />
    ))}
  </Row>
)

export default AnalyticsPdfOverviewCards
